module.exports = __webpack_public_path__ + "static/media/icon_data-Ignore.7ab96d42.svg";